import { Affix, Flex, Spin } from "antd";
import { ReactNode } from "react";
// const contentStyle: React.CSSProperties = {
//     padding: 50,
//     borderRadius: 4,
//     width : "100%"
// };
// const content = <div style={contentStyle} />;
interface ITelaCarregamentoProps {
    ativo?:boolean;
    texto?:string;
    children?:ReactNode;
}
export default function TelaCarregamento({
    ativo,
    texto,
    children
}:ITelaCarregamentoProps) {
    // ativo = ativo === undefined || ativo === null ? false : ativo;
    ativo = ativo ?? false;
    texto = texto ?? "Carregando...";
    children = children ?? <></>;

    return ativo && <Spin tip={texto} size="large" style={{ width : "100%" }} /> || children;
    // return ativo && <Affix style={{ position: 'absolute', top: 0, left: 0, width : "100%" }}>
    //     <Flex style={{
    //         width : "100%",
    //         // height : "100vh"
    //     }} justify="center" align="center">
    //         <Spin tip={texto} size="large" style={{ width : "100%" }}>
    //             <div style={contentStyle}>
    //                 {children}
    //             </div>
    //         </Spin>
    //     </Flex>
    // </Affix> || <></>;
}